import { FC } from "react";
import styles from "./ChallengeItem.module.scss";
import icon from "../../../icons/challenge.png";
import arrowIcon from "../../../icons/arrow.png";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../components/Menu/MenuButton";
import { IChallenge } from "../../../redux/challenges";
import { ChallengeTotalReward } from "../ChallengeTotalReward/ChallengeTotalReward";

interface IChallengeItemProps {
    id: number;
    challenge: IChallenge;
}

export const ChallengeItem: FC<IChallengeItemProps> = ({ id, challenge }) => {
    const navigate = useNavigate();
    const handler = () => navigate(`/${AppContext.Challenges}/${id}`);

    return (
        <div
            className={styles.challengeItem}
            onClick={handler}
        >
            <div className={styles.leftBlock}>
                <div className={styles.iconWrapper}>
                    <img
                        src={icon}
                        alt={challenge.name}
                        className={styles.icon}
                    />
                </div>

                <div className={styles.rewardLabel}>
                    Награда
                </div>
            </div>

            <div className={styles.challengeDetails}>
                <h3 className={styles.challengeTitle}>{challenge.name}</h3>
                <p className={styles.challengeStatus}>
                    <ChallengeTotalReward milestones={challenge.milestones} />
                </p>
            </div>

            <img src={arrowIcon} alt="arrow" className={styles.arrowIcon} />
        </div>
    );
}